import React, {Component} from 'react';
import {translate} from 'react-i18next';
import Popover from 'react-awesome-popover';
import config from '../../config/config.js';
import axios from 'axios';
import 'moment/locale/de';
import {Link} from 'react-router-dom';
import NameHelper from '../../helpers/nameHelper';

class SupporterGroup extends Component {
    constructor(props) {
        super(props);

        this.state = {
            group: false,
            open: false,
            loading: false
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.loadGroup = this.loadGroup.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
    }

    handleInputChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleOpen() {
        this.setState({
            open: true
        })
    }

    handleClose() {
        this.setState({
            group: false,
            open: false
        });
        this.props.handleClose();
    }

    loadGroup() {
        let that = this;
        axios(config.server.endpoint + 'backend/supporter/project/group/' + this.props.id, {
            method: 'get'
        }).then((response) => {
            if (response.status === 200) {
                that.setState({
                    open: true,
                    group: response.data
                });
            }
        });
    }

    render() {
        const { t } = this.props;
        return (
            <Popover onOpen={this.loadGroup} open={this.state.open} contentClass="rap-popover-content">
                <a>{this.props.name}</a>
                <div className="p-md" style={{width: 300}}>
                    <h2 style={{marginTop: 0}}>{this.state.group.name}</h2>
                    {this.state.group.members ? this.state.group.members.map((supporter, i) => (
                        <div key={i}>
                            <Link to={"/supporter/" + supporter.id} onClick={() => {if(this.props.onSupporterClick) this.props.onSupporterClick()}}>
                                {NameHelper.displayName(supporter)}
                            </Link>
                        </div>
                    )) : null}
                </div>
            </Popover>
        )
    }
}

export default translate()(SupporterGroup);